module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "chap2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle"
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "p_160"
    }
  }, [_vm._v("Claire was sitting on the closed toilet lid, knees together, arms hugging herself. She was a good-looking woman, a stylish woman, but fear had made her angular and jagged and old.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_161"
    }
  }, [_vm._v("Parker stayed in the doorway, his hand on the knob. “They're gone,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_162"
    }
  }, [_vm._v("She thawed slowly, straightening, her arms losing their tension, her face relaxing back toward something he recognized. She said, “Who-” and stopped because her voice was rusty. She coughed and cleared her throat, ducking her head in a gesture he knew, and looked up at him to say, “Who were they? What did they want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_163"
    }
  }, [_vm._v("“They didn't say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_164"
    }
  }, [_vm._v("“You can tell me,” she said. “This time, you can tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_165"
    }
  }, [_vm._v("He knew she meant the agreement they had that he wouldn't ever talk to her about the life he had when he was being Parker. He shook his head. “They didn't say. They were full of something I don't know about, and they wouldn't believe I wasn't in on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_166"
    }
  }, [_vm._v("She stood up, moving slowly as though she were stiff, holding on to the sink for support. “What did they want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_167"
    }
  }, [_vm._v("“To tell me not to get involved.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_168"
    }
  }, [_vm._v("“In what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_169"
    }
  }, [_vm._v("“They didn't say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_170"
    }
  }, [_vm._v("She frowned at him, frustrated, then suddenly grinned as though something unexpected had struck her funny. “Really?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_171"
    }
  }, [_vm._v("He nodded. “Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_172"
    }
  }, [_vm._v("“They came in and acted tough and told you not to get "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("involved and they wouldn't say in what?” She was grinning broadly now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_175"
    }
  }, [_vm._v("“Don't get hysterical,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_176"
    }
  }, [_vm._v("“I'm not going to get hysterical. I was afraid of them, really afraid of them, and they're just…silly. Just silly men.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_177"
    }
  }, [_vm._v("“Maybe,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_178"
    }
  }, [_vm._v("“I think I'll come out of the bathroom now,” she said, and her smile was more natural, as though maybe she wouldn't have hysterics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_179"
    }
  }, [_vm._v("“Fine,” he said. He put his hand out toward her and she took it, holding tight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_180"
    }
  }, [_vm._v("She came out to the main room and looked around. “They searched,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_181"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_182"
    }
  }, [_vm._v("“I don't suppose you know for what.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_183"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_184"
    }
  }, [_vm._v("She looked at him, and though she was still smiling her eyes were a little shadowed. “Shall we drink in the room,” she said, “or go out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_185"
    }
  }, [_vm._v("“Here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_186"
    }
  }, [_vm._v("“Good. I'll call.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_187"
    }
  }, [_vm._v("She let his hand go and walked between the beds to the stand with the phone, but just as she got to it it rang. She stopped, hand partway out toward the phone, and looked back at Parker to say, “Am I stupid? I want you to answer it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_188"
    }
  }, [_vm._v("“That's not stupid,” Parker said. The phone rang again as he went by her. He picked up the receiver, said, “Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_189"
    }
  }, [_vm._v("“Mr Walker?” The voice insinuated; it was made of oil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_190"
    }
  }, [_vm._v("“Yes,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_191"
    }
  }, [_vm._v("“Have they left?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_192"
    }
  }, [_vm._v("Parker stiffened. Out of the corner of his eye he could see Claire watching him, saw her react to his reaction. He said, “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_193"
    }
  }, [_vm._v("“I hope they were not…too much trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_194"
    }
  }, [_vm._v("“No,” Parker said. Claire was watching him as though to read the other half of the conversation on his forehead.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_196"
    }
  }, [_vm._v("“Did you make a decision?” the voice asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_197"
    }
  }, [_vm._v("“Not yet,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_198"
    }
  }, [_vm._v("“Then there might be some profit in our having a talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_199"
    }
  }, [_vm._v("“I don't know. Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_200"
    }
  }, [_vm._v("“Oh, you don't know me, Mr Walker. But let's say I was in your shoes once, that I might be able to offer you the benefit of my experience. Would you be interested?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_201"
    }
  }, [_vm._v("“Yes,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_202"
    }
  }, [_vm._v("“Then may I sug—” "), _c('i', [_vm._v("Click.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_203"
    }
  }, [_vm._v("The line was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_204"
    }
  }, [_vm._v("Parker said, “Hello?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_205"
    }
  }, [_vm._v("Claire said, “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_206"
    }
  }, [_vm._v("Parker shook his head. He put the receiver back on its cradle and said, “I don't like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_207"
    }
  }, [_vm._v("“What was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_208"
    }
  }, [_vm._v("“Another one. He wanted to know if they'd left, wanted to know if I'd like to have a talk with him. Then the connection got broken.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_209"
    }
  }, [_vm._v("“What are we going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_210"
    }
  }, [_vm._v("He looked at her. “Nothing,” he said. “If somebody else shows up, I'll try to find out what's going on. If not, we forget it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_211"
    }
  }, [_vm._v("“Can you? That easily?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_212"
    }
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_213"
    }
  }, [_vm._v("She spread her hands. “I don't know. Curiosity, something. Sometimes you don't seem-” She shrugged and turned away. “I don't think I want that drink after all,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_214"
    }
  }, [_vm._v("“What do you want instead?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_215"
    }
  }, [_vm._v("“Do you think we should go back? Back to Miami?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_216"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_217"
    }
  }, [_vm._v("She looked at him. “Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_218"
    }
  }, [_vm._v("He didn't tell her the reason. The reason was they were only at this hotel in New York for a few days, so if trouble happened here it couldn't louse up much. But in Miami they were known, they had a pattern developed; if there was "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("trouble down there it could spoil a lot of things. But to talk to her about trouble would only make her nervous, so he said, “Because we're here to shop. Some people got their wires crossed, but they'll find out it was a mistake and that's the end of it. They didn't tell me enough to make me dangerous to them, and after a while they'll find out I'm not in on their thing,”whatever it is, so they won't be back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_221"
    }
  }, [_vm._v("She looked dubious. “Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_222"
    }
  }, [_vm._v("“I'm not packing,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_223"
    }
  }, [_vm._v("She looked at the open suitcase on the bed. “You think it's safe to stay here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_224"
    }
  }, [_vm._v("“Yes. And I think you ought to go out. Go to some stores, buy some things. That's what you're here for. It'll get those three out of your head.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_225"
    }
  }, [_vm._v("“You won't come with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_226"
    }
  }, [_vm._v("“I'll cramp your style,” he told her. “Go on and buy things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_227"
    }
  }, [_vm._v("“I don't like this!” she said, suddenly bursting it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_228"
    }
  }, [_vm._v("Parker went over and put his hands on her arms. “They didn't hurt you,” he said. “They leaned a little and said don't get involved. So we're not getting involved, so it's all over. I know this kind of thing; you can take my word for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_229"
    }
  }, [_vm._v("She looked at him, and he could see her wanting to believe him. “Can I really?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_230"
    }
  }, [_vm._v("“You can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_231"
    }
  }, [_vm._v("She began to shiver. He pulled her in and held her, and the shivering settled down, and after a while she nodded against his jaw and said, “I'm all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_232"
    }
  }, [_vm._v("He let her go. “You want a drink now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_233"
    }
  }, [_vm._v("“No I will go shopping. That's what I was going to do this afternoon, so why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_234"
    }
  }, [_vm._v("“That's right,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_235"
    }
  }, [_vm._v("It took her five minutes to get ready. He sat on the bed and watched her, pleased by her existence but in a hurry for her to be gone, and when she'd kissed him and left he picked up the phone and called a number in uptown Manhattan\n "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("and asked to speak to Fred.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_238"
    }
  }, [_vm._v("“Speaking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_239"
    }
  }, [_vm._v("“This is Colt,” Parker said. “I need a traveling iron. Can I get one delivered to the hotel?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_240"
    }
  }, [_vm._v("“Are you a referral, Mr Colt?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_241"
    }
  }, [_vm._v("“A friend of mine named Parker recommended you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_242"
    }
  }, [_vm._v("“Oh, yes. Mr Parker, I remember him. Did you have any special kind of iron in mind, Mr Colt?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_243"
    }
  }, [_vm._v("“What do you have available?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_244"
    }
  }, [_vm._v("“Oh, most kinds. The thirty-two-dollar circular model, or the larger one at thirty-eight dollars. Or the forty-five-dollar automatic steam model. Then there are some nice German irons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_245"
    }
  }, [_vm._v("“The thirty-two-dollar model's good enough,” Parker said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_246"
    }
  }, [_vm._v("“Excellent. And you want that delivered?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_247"
    }
  }, [_vm._v("“Yes. Normanton Hotel, West Forty-sixth Street, room seven twenty-three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_248"
    }
  }, [_vm._v("“And that will be cash on delivery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_249"
    }
  }, [_vm._v("“Naturally,” said Parker. “How soon can it get here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_250"
    }
  }, [_vm._v("“Is this a rush order?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_251"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_252"
    }
  }, [_vm._v("“Hmmmm.” There was a silence, and then: “Within the hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_253"
    }
  }, [_vm._v("“Fine,” Parker said, and hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_254"
    }
  }, [_vm._v("Fifty minutes later there was a knock at the door. Parker opened and let in a messenger with a package. “Fifty bucks,” the messenger said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "p_255"
    }
  }, [_vm._v("Parker paid him, in cash, and he left. Parker opened the package and took out a Smith and Wesson Terrier .32-caliber revolver, a stubby five-shot pistol with a two-inch barrel. There was also a box of cartridges in the package. Parker loaded the revolver and tucked it away under the pillow of his bed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479e3878","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 75
// module chunks = 0